(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pw-quote-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pw-quote').forEach(function(root) {
    var main = root.querySelector('.pw-quote__image');
    var link = root.querySelector('.pw-quote__image-link');
    root.querySelectorAll('.pw-quote__thumb').forEach(function(button) {
      button.addEventListener('click', function() {
        main.removeAttribute('srcset');
        main.src = button.dataset.image;
        main.alt = button.dataset.alt;
        link.href = button.dataset.full;
        root.querySelectorAll('.pw-quote__thumb').forEach(function(item) { item.setAttribute('aria-pressed', String(item === button)); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
